import { useTranslation } from "react-i18next";
import { DefectTimeline } from "@/components/defects/DefectTimeline";
import { DefectCommentForm } from "@/components/defects/DefectCommentForm";
import { useDefectComments } from "@/hooks/useDefectComments";
import { DefectWithDetails } from "@/hooks/useDefectsQuery";
import { Separator } from "@/components/ui/separator";

interface DefectTimelineWithCommentsSectionProps {
  defectId: string;
  defect: DefectWithDetails;
  /**
   * When true, hide the comment form (read-only viewer). Used for fully read-only
   * external identities (partner_supplier / external_auditor) and the internal
   * customer_approver read-only role (TES-626 / TES-565). customer_acceptance
   * external users keep the form (limited-write). UI visibility is not the security
   * boundary — RLS / mig 296 enforce comment-write capability server-side.
   */
  readOnly?: boolean;
}

export function DefectTimelineWithCommentsSection({
  defectId,
  defect,
  readOnly = false,
}: DefectTimelineWithCommentsSectionProps) {
  const { t } = useTranslation();
  const { data: comments, isLoading } = useDefectComments(defectId);

  const canComment = !readOnly && defect.status !== "closed" && defect.status !== "cancelled";

  return (
    <div className="space-y-4">
      <DefectTimeline defect={defect} comments={comments} isLoading={isLoading} />

      {canComment && (
        <>
          <Separator />
          <div>
            <h4 className="text-sm font-medium mb-3">{t("defects.sendComment")}</h4>
            <DefectCommentForm
              defectId={defectId}
              defectTitle={defect.title}
              assignedToUserId={defect.assigned_to}
            />
          </div>
        </>
      )}
    </div>
  );
}
